let userInfo = {
  "pronoun":"he",
  "firstName": "Marc-André",
  "lastName": "Lavigne",
  "address": "hello@marcandre.ca",
}

export default userInfo
